import moment from "moment";

import { POLICY_STATE_REASON } from "consts";

export const acceptPaymentOnCancelledPolicy = (
  policyStatus,
  cancellationReason,
  renewalDate,
  minimumPaymentDue,
  isUnderMoratorium
) => {
  if (isUnderMoratorium) {
    return false;
  }

  const isCancelledPolicy = RegExp(/(^cancel)/gi).test(policyStatus);
  const isWithin20DaysOfRenewal =
    moment().diff(moment(renewalDate), "days") <= 20;
  const renewalWasNotAccepted =
    cancellationReason === POLICY_STATE_REASON.renewalNotAccepted;

  return (
    isCancelledPolicy &&
    renewalWasNotAccepted &&
    isWithin20DaysOfRenewal &&
    minimumPaymentDue > 0
  );
};
